import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Button } from '@mui/material';
import { CheckCircleOutline as CheckCircleOutlineIcon } from '@mui/icons-material';
import { useAuthRedirect, getSessionStatus, EnhancedErrorMessage, Loading } from '@virtual-cinema/client-lib';
import AudienceAppBar from '../common/app-bar';

const PaymentReturnPage = () => {
    const [sessionStatus, setSessionStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const accessToken = useAuthRedirect();

    useEffect(() => {
        const fetchSessionStatus = async () => {
            const searchParams = new URLSearchParams(location.search);
            const sessionId = searchParams.get('session_id');

            if (!sessionId) {
                setError('No session ID found');
                setIsLoading(false);
                return;
            }

            try {
                const { data, error } = await getSessionStatus(sessionId, accessToken);
                if (error) throw new Error(error);
                setSessionStatus(data);
                console.log("Fetch Session status data:", data);
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchSessionStatus();
    }, [location, accessToken]);

    const handleReturnToMyTickets = () => {
        navigate('/MyTickets');
    };

    console.log("Rendering Current sessionStatus:", sessionStatus);

    return (
        <Box sx={{ bgcolor: 'background.default', color: 'text.primary', minHeight: '100vh' }}>
            <AudienceAppBar />
            <Container maxWidth="md" sx={{ mt: 4 }}>
                {error ? (
                    <EnhancedErrorMessage message={error} />
                ) : isLoading ? (
                    <Loading />
                ) :
                    (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <CheckCircleOutlineIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
                            <Typography variant="h4" gutterBottom align="center">
                                Payment Successful!
                            </Typography>
                            <Typography variant="body1" paragraph align="center">
                                Thank you for your purchase. Your payment has been processed successfully.
                            </Typography>
                            {sessionStatus && (
                                <Box sx={{ mt: 2, mb: 4 }}>
                                    <Typography variant="body1">
                                        Payment Amount: {new Intl.NumberFormat('en-US', { style: 'currency', currency: sessionStatus.currency }).format(sessionStatus.amount_total / 100)}
                                    </Typography>
                                    <Typography variant="body1">
                                        Payment Status: {sessionStatus.payment_status}
                                    </Typography>
                                    <Typography variant="body1">
                                        Session Status: {sessionStatus.status}
                                    </Typography>
                                    {sessionStatus.customer_email && (
                                        <Typography variant="body1">
                                            Customer Email: {sessionStatus.customer_email}
                                        </Typography>
                                    )}
                                </Box>
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleReturnToMyTickets}
                                sx={{
                                    mt: 2,
                                    borderRadius: 20,
                                    px: 3,
                                    py: 1,
                                    textTransform: 'none',
                                }}
                            >
                                Return to MyTickets
                            </Button>
                        </Box>
                    )}
            </Container>
        </Box>
    );
};

export default PaymentReturnPage;